import type { SerializedCustomer } from '@enmon/commons/lib/enmon';
import type { BetterAuthClientPlugin } from 'better-auth/client';

export type SessionCustomerActions = {
  loginToCustomer: (customerId: SerializedCustomer['_id']) => Promise<void>;
  logoutFromCustomer: () => Promise<void>;
};

export const sessionCustomerClient = () =>
  ({
    id: 'enmon-session-customer',
    getActions: $fetch => ({
      loginToCustomer: (async (customerId: SerializedCustomer['_id']) => {
        await $fetch('/session/login-to-customer', {
          method: 'POST',
          body: { customerId },
        });
      }) satisfies SessionCustomerActions['loginToCustomer'],
      logoutFromCustomer: (async () => {
        await $fetch('/session/logout-from-customer', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
      }) satisfies SessionCustomerActions['logoutFromCustomer'],
    }),
  }) satisfies BetterAuthClientPlugin;
